import { render, staticRenderFns } from "./newShiftType.vue?vue&type=template&id=107bc4cc&"
import script from "./newShiftType.vue?vue&type=script&lang=js&"
export * from "./newShiftType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107bc4cc')) {
      api.createRecord('107bc4cc', component.options)
    } else {
      api.reload('107bc4cc', component.options)
    }
    module.hot.accept("./newShiftType.vue?vue&type=template&id=107bc4cc&", function () {
      api.rerender('107bc4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftType/newShiftType.vue"
export default component.exports